"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueriesStore = exports.createQueriesSetBase = void 0;
const mobx_1 = require("mobx");
const balances_1 = require("./balances");
const common_1 = require("../common");
const createQueriesSetBase = (kvStore, chainId, chainGetter) => {
    return {
        queryBalances: new balances_1.ObservableQueryBalances(kvStore, chainId, chainGetter),
    };
};
exports.createQueriesSetBase = createQueriesSetBase;
class QueriesStore {
    constructor(kvStore, chainGetter, ...queriesCreators) {
        this.kvStore = kvStore;
        this.chainGetter = chainGetter;
        this.queriesMap = new Map();
        this.queriesCreators = queriesCreators;
        mobx_1.makeObservable(this);
    }
    get(chainId) {
        if (!this.queriesMap.has(chainId)) {
            const queriesSetBase = exports.createQueriesSetBase(this.kvStore, chainId, this.chainGetter);
            mobx_1.runInAction(() => {
                const merged = common_1.mergeStores(queriesSetBase, [this.kvStore, chainId, this.chainGetter], ...this.queriesCreators);
                this.queriesMap.set(chainId, merged);
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.queriesMap.get(chainId);
    }
}
__decorate([
    mobx_1.observable.shallow
], QueriesStore.prototype, "queriesMap", void 0);
exports.QueriesStore = QueriesStore;
//# sourceMappingURL=queries.js.map